import React from "react";
import { BrowserRouter, Routes, Route, Link, useLocation, Navigate, useParams } from "react-router-dom";
import "./App.css";
import "./site/site.css";
import MobileApp from "./MobileApp";
import { SiteLayout } from "./site/SiteShell";
import { I18nProvider } from "./site/i18n";
import { HomePage, TechnologyPage, AIAgentPage, SocialPage, AppInfoPage,
  BusinessPage, MarketplacePage, AcademyPage, CharityPage, PageHero,
  HowItWorksPage, StakingInfoPage } from "./site/pages";
import { InvestorsPage, TokenomicsPage, RoadmapPage, DocumentsPage,
  TeamPage, LegalPage, ContactPage } from "./site/pages2";
import { ReferralPage, CardPage, PayPage, SecurityPage, StatsPage } from "./site/pages3";
import { LoginPage, RegisterPage, ExchangePage, SwiftPage, P2PPage, AcquiringPage, FAQParticipantsPage } from "./site/functional";
import Dashboard from "./dashboard/Dashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Legacy short referral URL: /r/CODE  →  /register?ref=CODE
// Also persists the code into localStorage for 30 days so if the user
// navigates away and returns later (without the URL), signup still attributes.
function ReferralRedirect() {
  const { code } = useParams();
  React.useEffect(() => {
    try {
      if (code) {
        const payload = { code: code.toUpperCase(), savedAt: Date.now() };
        localStorage.setItem("tgc_pending_ref", JSON.stringify(payload));
      }
    } catch (e) { /* ignore storage errors */ }
  }, [code]);
  return <Navigate to={`/register?ref=${(code || "").toUpperCase()}`} replace />;
}

function NotFound() {
  return (
    <main data-testid="page-404">
      <PageHero eyebrow="404" title={<>Страница <span className="accent">не найдена</span></>}
        lead="Возможно, вы перешли по устаревшей ссылке. Вот основные разделы:" />
      <section className="tg-page tg-section-tight">
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to="/" className="tg-btn primary">На главную</Link>
          <Link to="/register" className="tg-btn gold">Регистрация</Link>
          <Link to="/app" className="tg-btn ghost">Запустить App</Link>
        </div>
      </section>
    </main>
  );
}

function SiteRoute({ children }) {
  return <SiteLayout>{children}</SiteLayout>;
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Mobile PWA app */}
          <Route path="/app" element={<MobileApp />} />

          {/* Personal Cabinet (Web Dashboard) */}
          <Route path="/dashboard/*" element={<Dashboard />} />

          {/* AUTH */}
          <Route path="/login"    element={<SiteRoute><LoginPage /></SiteRoute>} />
          <Route path="/register" element={<SiteRoute><RegisterPage /></SiteRoute>} />

          {/* Legacy short referral link: /r/<CODE>  →  /register?ref=<CODE> */}
          <Route path="/r/:code"  element={<ReferralRedirect />} />

          {/* Participant pages */}
          <Route path="/"                element={<SiteRoute><HomePage /></SiteRoute>} />
          <Route path="/how-it-works"    element={<SiteRoute><HowItWorksPage /></SiteRoute>} />
          <Route path="/technology"      element={<SiteRoute><TechnologyPage /></SiteRoute>} />
          <Route path="/ai-agent"        element={<SiteRoute><AIAgentPage /></SiteRoute>} />
          <Route path="/social"          element={<SiteRoute><SocialPage /></SiteRoute>} />
          <Route path="/app-info"        element={<SiteRoute><AppInfoPage /></SiteRoute>} />
          <Route path="/pay"             element={<SiteRoute><PayPage /></SiteRoute>} />
          <Route path="/card"            element={<SiteRoute><CardPage /></SiteRoute>} />
          <Route path="/staking-info"    element={<SiteRoute><StakingInfoPage /></SiteRoute>} />
          <Route path="/referral-program"element={<SiteRoute><ReferralPage /></SiteRoute>} />
          <Route path="/exchange"        element={<SiteRoute><ExchangePage /></SiteRoute>} />
          <Route path="/swift"           element={<SiteRoute><SwiftPage /></SiteRoute>} />
          <Route path="/p2p"             element={<SiteRoute><P2PPage /></SiteRoute>} />
          <Route path="/acquiring"       element={<SiteRoute><AcquiringPage /></SiteRoute>} />
          <Route path="/business"        element={<SiteRoute><BusinessPage /></SiteRoute>} />
          <Route path="/marketplace"     element={<SiteRoute><MarketplacePage /></SiteRoute>} />
          <Route path="/academy"         element={<SiteRoute><AcademyPage /></SiteRoute>} />
          <Route path="/charity"         element={<SiteRoute><CharityPage /></SiteRoute>} />
          <Route path="/stats"           element={<SiteRoute><StatsPage /></SiteRoute>} />

          {/* Company */}
          <Route path="/team"     element={<SiteRoute><TeamPage /></SiteRoute>} />
          <Route path="/security" element={<SiteRoute><SecurityPage /></SiteRoute>} />
          <Route path="/faq"      element={<SiteRoute><FAQParticipantsPage /></SiteRoute>} />
          <Route path="/legal"    element={<SiteRoute><LegalPage /></SiteRoute>} />
          <Route path="/contact"  element={<SiteRoute><ContactPage /></SiteRoute>} />

          {/* Investor pages — доступны по прямым ссылкам, НЕТ в меню */}
          <Route path="/investors"  element={<SiteRoute><InvestorsPage /></SiteRoute>} />
          <Route path="/tokenomics" element={<SiteRoute><TokenomicsPage /></SiteRoute>} />
          <Route path="/roadmap"    element={<SiteRoute><RoadmapPage /></SiteRoute>} />
          <Route path="/documents"  element={<SiteRoute><DocumentsPage /></SiteRoute>} />

          <Route path="*" element={<SiteRoute><NotFound /></SiteRoute>} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}
